import React from 'react'
import PropTypes from 'prop-types'
import {injectIntl } from 'react-intl'

import Label from '../label'

import {
    asset,
    AppRegistry,
    Pano,
    View,
    Video,
    VideoControl,
    MediaPlayerState,
} from 'react-vr';


import Error from './form-input-error'

class InputVideo extends React.Component {
    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array
        ]),
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        waitInMs: PropTypes.number
    }

    constructor(props){
        super(props);
        this.state = {
            playerState: new MediaPlayerState({autoPlay: true, muted: true}), // init with muted, autoPlay
            value: props.value,
            error: false
        };
        this.onChangeTimeout = false;
    }


    render() {
        let { intl, label=false, placeholder=false, className=false, errorStr='app.error', disabled } = this.props;
        let { error, value, loading } = this.state;

        return <div className={"form form-text" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>

            <div className={'form-data' + (error?' error':'')}>
                {(disabled || loading) ? <div className="disabled">{value}</div> :
                    <View>
                        <Pano source={asset('chess-world.jpg')} />
                        <View
                            style={{
                                alignItems: 'center',
                                layoutOrigin: [0.5, 0.5, 0],
                                transform: [{translate: [0, 0, -4]}],
                            }}>
                            <Video
                                style={{height: 2.25, width: 4}}
                                source={[
                                    asset('video.mp4', {format: 'mp4'}),
                                    asset('video.webm', {format: 'webm'}),
                                ]}
                                playerState={this.state.playerState}
                            />
                            <VideoControl style={{height: 0.2, width: 4}} playerState={this.state.playerState} />
                        </View>
                    </View>}
                {error && <Error visible={error} message={errorStr} />}
            </div>
        </div>
    }
}

InputVideo.defaultProps = {
    errorStr: 'app.error',
    value: ''
}

export default injectIntl(InputVideo)

